import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthService } from 'src/app/core/services/auth.services';

@Component({
  selector: 'mb-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
  loading = false;
  isLoggedIn= false;
  isIframe = false;
  loggedIn: boolean=false;
  constructor(
    private _authservices: AuthService,
    private _authService: MsalService,
    private _router: Router
  ) {}
  ngOnInit() {
    this.isIframe = window !== window.parent && !window.opener;

  }
  checkoutAccount() {
    this.isLoggedIn = this._authservices.isLoggedIn();//-msal// !!this._authService.getAccount();
    if(!this.isLoggedIn)
    this._router.navigate(['login']);

  }

  login() {
    this._authService.loginRedirect();
  }

  logout() {
    this._authService.logout();
  }
}
